import {css} from "lit";

export const copyLinkOnDarkStyle = css`
    --_copy-button__bg: var(--sbkBannerBoxColorBgColorEmphasised);
`;
